import type { PropsWithChildren, FC, SVGProps } from 'react';

import { svgIconRecipe } from './IconWrapper.css';
import { DynamicVariantProp } from '../types';
import { getClassNames } from '../util/css';

const sparkyClassName = 'icon-sparky';

type SvgIconVariants = NonNullable<Parameters<typeof svgIconRecipe>[0]>;

export type IconColor = SvgIconVariants['color'];
export type IconSize = SvgIconVariants['size'];
export type IconStroke = SvgIconVariants['stroke'];

export type IconProps = {
  color?: Exclude<IconColor, undefined>;
  size?: Exclude<IconSize, undefined>;
  stroke?: Exclude<IconStroke, undefined>;
  verticalAlign?: Extract<
    DynamicVariantProp<'verticalAlign'>,
    'baseline' | 'top' | 'middle' | 'bottom' | 'sub' | 'super' | 'text-top' | 'text-bottom'
  >;
};

export const Icon: FC<PropsWithChildren<IconProps>> = ({ children, color, size, stroke, verticalAlign = 'bottom' }) => {
  const iconClassNames = getClassNames(svgIconRecipe({ color, size, stroke, verticalAlign }), sparkyClassName);
  return (
    <svg aria-hidden="true" className={iconClassNames} viewBox="0 0 24 24">
      {children}
    </svg>
  );
};

Icon.toString = () => `.${sparkyClassName}`;

export function withIconWrapper(SvgIcon: FC<SVGProps<SVGGElement>>): FC<IconProps> {
  return function WrappedIcon({ color, size, stroke, verticalAlign, ...rest }) {
    return (
      <Icon color={color} size={size} stroke={stroke} verticalAlign={verticalAlign}>
        <SvgIcon {...rest} />
      </Icon>
    );
  };
}


